module.exports = __webpack_public_path__ + "img/1.7fd160b5.png";